import { render, staticRenderFns } from "./BodyStagePreview.vue?vue&type=template&id=6edffa10&scoped=true&"
import script from "./BodyStagePreview.vue?vue&type=script&lang=js&"
export * from "./BodyStagePreview.vue?vue&type=script&lang=js&"
import style0 from "./BodyStagePreview.vue?vue&type=style&index=0&id=6edffa10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edffa10",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
